import { t as e } from "../../constants-B7fXbm2f.js";
import { t } from "../../_plugin-vue_export-helper-B52Kst-M.js";
import { createElementBlock as n, createElementVNode as r, normalizeClass as i, openBlock as a } from "vue";
//#region ../src/icons/bell-plus.vue
var o = {
	name: "DtIconBellPlus",
	props: {
		size: {
			type: String,
			default: "500",
			validator: (t) => Object.keys(e).includes(t)
		},
		ariaLabel: {
			type: String,
			default: void 0
		}
	},
	emits: ["loaded"],
	computed: {
		iconSizeClass() {
			return e[this.size];
		},
		ariaHidden() {
			return this.ariaLabel ? "false" : "true";
		},
		dataQA() {
			return this.$attrs["data-qa"] ?? "dt-icon";
		}
	},
	created() {
		this.$emit("loaded");
	}
}, s = [
	"aria-label",
	"data-qa",
	"aria-hidden"
];
function c(e, t, o, c, l, u) {
	return a(), n("svg", {
		"aria-label": o.ariaLabel,
		class: i([u.iconSizeClass, "d-icon d-icon--bell-plus"]),
		"data-qa": u.dataQA,
		"aria-hidden": u.ariaHidden,
		role: "img",
		"data-name": "Bell Plus",
		viewBox: "0 0 12 12",
		xmlns: "http://www.w3.org/2000/svg"
	}, [...t[0] || (t[0] = [r("path", {
		"fill-rule": "evenodd",
		"clip-rule": "evenodd",
		d: "M6.417 1.535A2.5 2.5 0 0 0 3.5 4c0 1.824-.391 3.033-.811 3.802-.038.07-.076.136-.114.198h6.85c-.268-.44-.541-1.056-.72-1.896a.5.5 0 0 1 .977-.208c.19.884.489 1.446.724 1.776.118.166.222.277.29.341.035.033.06.054.075.065l.012.01A.5.5 0 0 1 10.5 9h-9a.5.5 0 0 1-.277-.916L1.5 8.5l-.277-.416H1.22v.002h-.003a1.513 1.513 0 0 0 .153-.142c.113-.117.274-.317.44-.62.33-.607.689-1.648.689-3.324A3.5 3.5 0 0 1 6.583.549a.5.5 0 1 1-.166.986Zm-1.533 8.533a.5.5 0 0 1 .683.181.5.5 0 0 0 .865 0 .5.5 0 0 1 .865.502 1.5 1.5 0 0 1-2.595 0 .5.5 0 0 1 .182-.683Z",
		fill: "currentColor"
	}, null, -1), r("path", {
		d: "M9.5 1a.5.5 0 0 0-1 0v1h-1a.5.5 0 0 0 0 1h1v1a.5.5 0 0 0 1 0V3h1a.5.5 0 0 0 0-1h-1V1Z",
		fill: "currentColor"
	}, null, -1)])], 10, s);
}
var l = /* @__PURE__ */ t(o, [["render", c]]);
//#endregion
export { l as default };

//# sourceMappingURL=bell-plus.js.map